<template>
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="el-card pd20 search">
        <div class="search-child">
            <!-- 海报状态： -->
            <label >海报状态：</label>
            <el-select  v-model="status" placeholder="请选择海报状态" clearable>
                <el-option   label="未生效" :value="0">未生效</el-option>
                <el-option   label="生效" :value="1">生效</el-option>
            </el-select>
            
        </div>
        <div class="search-child">
            <!-- 关联活动 -->
            <label >关联活动：</label>
            <el-select  v-model="activity_id" placeholder="请选择关联活动" clearable>
                <el-option  v-for="(item,index) in activityArr" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
            </el-select>
        </div>
        <div class="search-child on">
            <!-- 海报名称 -->
            <label >海报名称：</label>
            <el-input class="input" v-model="name" placeholder="请输入海报名称"></el-input>
            
            <el-button type="primary" class="btn" @click="pullData"  size="small">查&nbsp;&nbsp;询</el-button>
            <el-button type="primary"  @click="posterHandle()"  size="small">添加海报</el-button>
        </div>
        
    </div>
    <div class="main">
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <!-- <el-table-column prop="id" label="海报ID"></el-table-column> -->
          <el-table-column prop="name" label="海报名称"></el-table-column>
          <el-table-column label="关联活动">
              <template slot-scope="scope">
                  <span v-for="(item,index) in activityArr" :key="index" v-if="item.id==scope.row.activity_id">{{item.name}}</span>
              </template>
          </el-table-column>
<!--           
          <el-table-column prop="image_id" label="图片ID"></el-table-column> -->
          <el-table-column  label="背景图">
              <template slot-scope="scope">
                  <div class="userinfo">
                        <img v-if="scope.row.image_url" :src="scope.row.image_url" alt="">
                    </div>
              </template>
          </el-table-column>

          <el-table-column  label="状态">
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.status==0" type="info" size="medium">未生效</el-tag>
                  <el-tag v-else size="medium">生效</el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column prop="update_time" label="修改时间"></el-table-column>
          <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="posterHandle(scope.$index, scope.row)" >编辑</el-button>
                  <el-button type="danger" size="mini"  @click="delHandle(scope.$index, scope.row)" >删除</el-button>
                  <el-button type="info" size="mini"  v-clipboard:copy="isMain?`https://open.xjy.cn/main/poster_generation?id=${scope.row.id}`:`https://open.xjy.cn/test/poster_generation?id=${scope.row.id}`" v-clipboard:success="onCopy"  v-clipboard:error="onError" >复制地址</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination class="pages" removePoster
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pages.size" 
        :current-page="pages.page"
        background 
        layout="sizes,prev, pager, next" 
        :total="pages.count"> 
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { posterList,activityAll,deletePoster  } from "@/api/operating";
import { isMain  } from "@u/tools";

export default {
    data() {
        return{
            list: [],
            pages: {},
            name:'',
            status:null,
            activity_id:null,
            activityArr:[],
            isMain:isMain()
        }
    },
    methods:{
        onCopy: function(e) {
            this.$message.success("复制成功，直接粘贴即可！");
        },
        onError: function(e) {
            this.$message.error("复制失败，请重试！");
        },
        /*
         *@param: 
         *@return: 
         *@Description: 删除
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:26:26
        */
        delHandle(index,row){
            this.$confirm('确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePoster({
                    id:row.id
                }).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return;
                    }
                    this.$notify({
                        title: '成功',
                        message: '删除成功！',
                        type: 'success'
                    });
                });
            });
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 海报编辑
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 12:50:16
        */
        posterHandle(index,row){
            let obj = {};
            if(row && row.id){
                obj['id'] = row.id;
            }
            this.$router.push({
                path:'/main/poster_builder_form',
                query:obj
            });
        },
        
        // 初始化获取数据
        pullData(){
            this.$showLoading();
            let obj = {
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null,   //每页数量，默认25
            };
            if(this.name !=''){
                obj['name'] = this.name;
            }
            if(this.status || this.status=='0'){
                obj['status'] = this.status;
            }
            if(this.activity_id){
                obj['activity_id'] = this.activity_id;
            }

            posterList(obj).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return;
                }
                this.list = data.list;
                this.pages = data.pager;
                
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            if(this.activityArr.length==0){
                activityAll().then(data=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return;
                    }
                    this.activityArr = data.list;

                });
            }
            
        }
    },
    created(){
        this.pullData();
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content:center;
    img{
        width: 80px;
        border-radius: 10px;
        margin-right: 15px;
    }
}
.search{
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .search-child{
        display: flex;
        align-items: center;
        flex:1;
        label{
            font-size: 16px;
            color: #606266;
        }
        .input{
            width: 200px;
        }
        .btn{
            margin-left: auto;
        }
    }
    .search-child.on{
        flex:1.5;
    }
    
}
</style>
